import React, { useContext, useEffect, useState } from "react";
import { Popover } from "@headlessui/react";
import { Link, NavLink } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import ArrowSmallRight from "./reusable/icons/ArrowSmallRight";
import Documents from "./reusable/icons/Documents";
import { HiChevronRight } from "react-icons/hi2";
import Dashboard from "../assets/images/sidebar_icon1.svg";
import User from "../assets/images/sidebar_icon2.svg";
import Services from "../assets/images/sidebar_icon3.svg";
import Features from "../assets/images/sidebar_icon4.svg";
import Transaction from "../assets/images/sidebar_icon7.svg";
import Reports from "../assets/images/sidebar_icon8.svg";
import Setting from "../assets/images/sidebar_icon9.svg";
import { FaAddressCard, FaBuilding } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const classNames = require("classnames");
const Sidebar = () => {
  const { t } = useTranslation();

  const { user, sidebarStatus, handleSidebar, updatePageName, settingsLogo } =
    useContext(AuthContext);
  const [staticPopup, setStaticPopup] = useState(false);
  const [masterDataPopup, setMasterDataPopup] = useState(false);
  const [careersPopup, setCareersPopup] = useState(false);
  const [isStaticPagePermission, setIsStaticPagePermission] = useState(false);
  const [isMasterDataPermission, setIsMasterDataPermission] = useState(false);
  const [isCareersPermission, setIsCareersPermission] = useState(false);
  const [isTestPermission, setIsTestPermission] = useState(false);
  const [testPopup, setTestPopup] = useState(false);
  const [trainingPopup, setTrainingPopup] = useState(false);
  const checkSidebarPermission = (arg) => {
    if (!user) {
      return false;
    }
    const localPermissions = user.permission ? [...user.permission] : {};

    if (user?.permission?.length === 0) {
      return true;
    }

    const perIndex =
      localPermissions?.length &&
      localPermissions?.findIndex((item) => item?.manager === arg);
    if (perIndex < 0) {
      return false;
    }
    if (localPermissions?.[perIndex]?.view) {
      return true;
    }
  };

  const handleCheckPermission = (checkPermissions) => {
    for (let index = 0; index < checkPermissions.length; index++) {
      const isTempPermission = checkSidebarPermission(checkPermissions[index]);
      if (isTempPermission) {
        return isTempPermission;
      }
    }
    return false;
  };

  useEffect(() => {
    const checkPermissionUsers = [
      "about_us",
      "contact_us",
      "faqs",
      "privacy_policy",
      "terms_and_conditions",
      "bank_manager",
    ];
    const staticPermission = handleCheckPermission(checkPermissionUsers);
    setIsStaticPagePermission(staticPermission);

    const checkPermissionCategories = [
      "property_type_manager",
      "property_category_manager",
      "amenities_manager",
      "test_manager",
      "bank_manager",
    ];
    const masterDataPermission = handleCheckPermission(
      checkPermissionCategories,
    );
    setIsMasterDataPermission(masterDataPermission);

    const checkPermissionCareers = ["careers"];
    const careersPermission = handleCheckPermission(checkPermissionCareers);
    setIsCareersPermission(careersPermission);

    setIsTestPermission(handleCheckPermission(["test_manager"]) || false);
  }, [handleCheckPermission]);

  return (
    <>
      {" "}
      <div
        className={`sidebar lg:block z-10 bg-[#F9F9F9]  ${
          sidebarStatus === "open" ? "block" : "hidden"
        }  w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
        onClick={handleSidebar}
      >
        <div className="text-[#585874] border-r border-[#eee]">
          <Link
            to="/dashboard"
            onClick={() => updatePageName("Dashboard")}
            className="px-2 py-[7px]  border-b border-b[#eee] w-full text-center flex justify-center"
          >
            <img src={"../images/logo.svg"} className="inline" alt="logo" />
          </Link>
          <div className="profile text-center">
            {/* <figure className='inline-block overflow-hidden rounded-full border-4 border-lightpurple mb-2.5'>
              <OImage
                src={user?.profile_pic}
                fallbackUrl='/images/user.png'
                className='w-20 h-20'
              />
            </figure> */}
          </div>
          <nav className="pt-0 pb-5 flex flex-col justify-center font-normal text-xs overflow-y-auto">
            {checkSidebarPermission("dashboard") && (
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_DASHBOARD"))}
              >
                <span className="mr-2">
                  <img src={Dashboard} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_DASHBOARD")}
              </NavLink>
            )}
            {checkSidebarPermission("bank_manager") && (
              <NavLink
                to="/bank-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName("Banks Manager")}
              >
                <FaBuilding size={18} />
                <span className="ms-2">Banks Manager</span>
              </NavLink>
            )}

            {checkSidebarPermission("sub_admin_manager") && (
              <NavLink
                to="/sub-admin-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_SUB_ADMIN_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_SUB_ADMIN_MANAGER")}
              </NavLink>
            )}

            {checkSidebarPermission("customers") && (
              <NavLink
                to="/users"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("O_CUSTOMERS"))}
              >
                <span className="mr-2">
                  <img src={User} className="max-w-[18px]" alt="" />
                </span>
                {t("O_CUSTOMERS")}
              </NavLink>
            )}

            {checkSidebarPermission("company_manager") && (
              <NavLink
                to="/company"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_MANAGE_COMPANY"))}
              >
                <span className="mr-2">
                  <img src={Transaction} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_MANAGE_COMPANY")}
              </NavLink>
            )}
            {checkSidebarPermission("agent_manager") && (
              <NavLink
                to="/agents"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_AGENT_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_AGENT_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("activity_tracker_manager") && (
              <NavLink
                to="/activity-tracker"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName("Activity Tracker")}
              >
                <span className="mr-2">
                  <img src={Dashboard} className="max-w-[18px]" alt="" />
                </span>
                Activity Tracker
              </NavLink>
            )}
            {isMasterDataPermission && (
              <Popover className="relative">
                {() => (
                  <>
                    <Popover.Button
                      onClick={() => setMasterDataPopup(!masterDataPopup)}
                      style={{ width: "100%" }}
                      className="outline-none text-start  flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]"
                    >
                      <span className="mr-2">
                        <Documents />
                      </span>
                      {t("NAV_MASTER_DATA")}{" "}
                      <span className="mr-2">
                        <HiChevronRight
                          className={
                            masterDataPopup
                              ? "text-lg ml-2 rotate-90 transform"
                              : "text-lg ml-2"
                          }
                        />
                      </span>
                    </Popover.Button>
                    {masterDataPopup && (
                      <Popover.Panel className="" static>
                        {checkSidebarPermission("property_type_manager") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/property-types"
                            onClick={() =>
                              updatePageName(t("NAV_PROPERTY_TYPE_MANAGER"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_PROPERTY_TYPE_MANAGER")}
                          </NavLink>
                        )}

                        {checkSidebarPermission(
                          "property_category_manager",
                        ) && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/property-categories"
                            onClick={() =>
                              updatePageName(t("NAV_PROPERTY_CATEGORY_MANAGER"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_PROPERTY_CATEGORY_MANAGER")}
                          </NavLink>
                        )}

                        {checkSidebarPermission("amenities_manager") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/amenities"
                            onClick={() =>
                              updatePageName(t("NAV_AMENITIES_MANAGER"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_AMENITIES_MANAGER")}
                          </NavLink>
                        )}
                      </Popover.Panel>
                    )}
                  </>
                )}
              </Popover>
            )}
            {checkSidebarPermission("auction_manager") && (
              <NavLink
                to="/auction"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_PROPERTY_AUCTION_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_AUCTION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("approval_manager") && (
              <NavLink
                to="/approval-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_APPROVAL_MANAGER"))}
              >
                <span className="mr-2">
                  <img
                    src={Services}
                    className="max-w-[18px] color-green-500"
                    alt=""
                  />
                </span>
                {t("NAV_APPROVAL_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("query_listing_manager") && (
              <NavLink
                to="/query-manager"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_QUERY_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_QUERY_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("ads_and_banner_manager") && (
              <NavLink
                to="/ads"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_PROPERTY_ADS_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_ADS_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("report-reason") && (
              <NavLink
                to="/report-reason"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("REPORT_REASON"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("REPORT_REASON")}
              </NavLink>
            )}
            {checkSidebarPermission("marketing_material_manager") && (
              <NavLink
                to="/marketing-material"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_PROPERTY_MARKETING_MATERIAL_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_MARKETING_MATERIAL_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("transaction_manager") && (
              <NavLink
                to="/transactions"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_PROPERTY_TRANSACTION_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_TRANSACTION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("reports_manager") && (
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_PROPERTY_REPORTS_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img src={Reports} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_REPORTS_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("notification_managers") && (
              <NavLink
                to="/notifications"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() =>
                  updatePageName(t("NAV_PROPERTY_NOTIFICATION_MANAGER"))
                }
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_NOTIFICATION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("blog_manager") && (
              <NavLink
                to="/blogs"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_BLOG_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_BLOG_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("location_manager") && (
              <NavLink
                to="/city"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName("Cities")}
              >
                <span className="mr-2">
                  <FaAddressCard style={{ fontSize: 17 }} />
                </span>
                {t("NAV_Location_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("subscription_manager") && (
              <NavLink
                to="/subscriptions"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_SUBSCRIPTION_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Features} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_SUBSCRIPTION_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("property_manager") && (
              <NavLink
                to="/properties"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_PROPERTY_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROPERTY_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("project_manager") && (
              <NavLink
                to="/projects"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_PROJECT_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROJECT_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("unit_manager") && (
              <NavLink
                to="/units"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("UNIT_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("UNIT_MANAGER")}
              </NavLink>
            )}

            {isTestPermission && (
              <Popover className="relative">
                {() => (
                  <>
                    <Popover.Button
                      onClick={() => setTestPopup(!testPopup)}
                      style={{ width: "100%" }}
                      className="outline-none text-start  flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]"
                    >
                      <span className="mr-2">
                        <Documents />
                      </span>
                      {t("TEST_MANAGER")}{" "}
                      <span className="mr-2">
                        <HiChevronRight
                          className={
                            testPopup
                              ? "text-lg ml-2 rotate-90 transform"
                              : "text-lg ml-2"
                          }
                        />
                      </span>
                    </Popover.Button>
                    {testPopup && (
                      <Popover.Panel className="" static>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/test-manager/tests"
                          end
                          onClick={() => updatePageName(t("TESTS"))}
                        >
                          <ArrowSmallRight />
                          {t("TESTS")}
                        </NavLink>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/test-manager/questions"
                          onClick={() => updatePageName(t("Questions"))}
                        >
                          <ArrowSmallRight />
                          {t("Questions")}
                        </NavLink>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/test-manager/question-bank"
                          onClick={() => updatePageName(t("O_QUESTION_BANK"))}
                        >
                          <ArrowSmallRight />
                          {t("O_QUESTION_BANK")}
                        </NavLink>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/test-manager/submissions"
                          onClick={() =>
                            updatePageName(t("O_TESTS_SUBMISSIONS"))
                          }
                        >
                          <ArrowSmallRight />
                          {t("O_TESTS_SUBMISSIONS")}
                        </NavLink>
                      </Popover.Panel>
                    )}
                  </>
                )}
              </Popover>
            )}

            {(user?.role === "admin" ||
              checkSidebarPermission("training_session_manager")) && (
              <Popover className="relative">
                {() => (
                  <>
                    <Popover.Button
                      onClick={() => setTrainingPopup(!trainingPopup)}
                      style={{ width: "100%" }}
                      className="outline-none text-start flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]"
                    >
                      <span className="mr-2">
                        <Documents />
                      </span>
                      Training Manager{" "}
                      <span className="mr-2">
                        <HiChevronRight
                          className={
                            trainingPopup
                              ? "text-lg ml-2 rotate-90 transform"
                              : "text-lg ml-2"
                          }
                        />
                      </span>
                    </Popover.Button>
                    {trainingPopup && (
                      <Popover.Panel className="" static>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/training-sessions"
                          end
                          onClick={() => updatePageName("Training Sessions")}
                        >
                          <ArrowSmallRight />
                          Training Sessions
                        </NavLink>
                        <NavLink
                          className={({ isActive }) =>
                            classNames(
                              "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                              {
                                active: isActive,
                              },
                            )
                          }
                          to="/training-sessions/submissions"
                          onClick={() =>
                            updatePageName("Training Submissions")
                          }
                        >
                          <ArrowSmallRight />
                          Training Submissions
                        </NavLink>
                      </Popover.Panel>
                    )}
                  </>
                )}
              </Popover>
            )}

            {checkSidebarPermission("units_report_manager") && (
              <NavLink
                to="/units-report"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName("Units Report")}
              >
                <span className="mr-2">
                  <img src={Reports} className="max-w-[18px]" alt="" />
                </span>
                {t("UNITS_REPORTS")}
              </NavLink>
            )}
            {checkSidebarPermission("project_floor_manager") && (
              <NavLink
                to="/project-floors"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_PROJECT_FLOOR_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_PROJECT_FLOOR_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("order_manager") && (
              <NavLink
                to="/orders"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_ORDER_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_ORDER_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("order_discounts") && (
              <NavLink
                to="/order-discounts"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_ORDER_DISCOUNT"))}
              >
                <span className="mr-2">
                  <img src={Services} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_ORDER_DISCOUNT")}
              </NavLink>
            )}


            {isCareersPermission && (
              <Popover className="relative">
                {() => (
                  <>
                    <Popover.Button
                      onClick={() => setCareersPopup(!careersPopup)}
                      style={{ width: "100%" }}
                      className="outline-none text-start  flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]"
                    >
                      <span className="mr-2">
                        <Documents />
                      </span>
                      {t("NAV_CAREERS_MANAGER")}{" "}
                      <span className="mr-2">
                        <HiChevronRight
                          className={
                            careersPopup
                              ? "text-lg ml-2 rotate-90 transform"
                              : "text-lg ml-2"
                          }
                        />
                      </span>
                    </Popover.Button>
                    {careersPopup && (
                      <Popover.Panel className="" static>
                        {checkSidebarPermission("careers") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/careers"
                            end
                            onClick={() =>
                              updatePageName(t("NAV_CAREERS_MANAGER"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_CAREERS_MANAGER")}
                          </NavLink>
                        )}
                        {checkSidebarPermission("careers") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/careers/applications"
                            onClick={() => updatePageName(t("Applications"))}
                          >
                            <ArrowSmallRight />
                            {t("Applications")}
                          </NavLink>
                        )}
                        {checkSidebarPermission("careers") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/careers/recruiters"
                            onClick={() =>
                              updatePageName(t("Recruiters") || "Recruiters")
                            }
                          >
                            <ArrowSmallRight />
                            {t("Recruiters") || "Recruiters"}
                          </NavLink>
                        )}
                        {checkSidebarPermission("careers") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/careers/resume-catalog"
                            onClick={() =>
                              updatePageName(t("Resume Catalog") || "Resume Catalog")
                            }
                          >
                            <ArrowSmallRight />
                            {t("Resume Catalog") || "Resume Catalog"}
                          </NavLink>
                        )}
                        {checkSidebarPermission("careers") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/onboarding-requests"
                            onClick={() =>
                              updatePageName(t("NAV_ONBOARDING_CANDIDATES"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_ONBOARDING_CANDIDATES")}
                          </NavLink>
                        )}
                      </Popover.Panel>
                    )}
                  </>
                )}
              </Popover>
            )}

            {isStaticPagePermission && (
              <Popover className="relative">
                {() => (
                  <>
                    <Popover.Button
                      onClick={() => setStaticPopup(!staticPopup)}
                      style={{ width: "100%" }}
                      className="outline-none text-start  flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]"
                    >
                      <span className="mr-2">
                        <Documents />
                      </span>
                      {t("NAV_STATIC_CONTENTS")}{" "}
                      <span className="mr-2">
                        <HiChevronRight
                          className={
                            staticPopup
                              ? "text-lg ml-2 rotate-90 transform"
                              : "text-lg ml-2"
                          }
                        />
                      </span>
                    </Popover.Button>
                    {staticPopup && (
                      <Popover.Panel className="" static>
                        {checkSidebarPermission("about_us") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/static/about-us"
                            onClick={() => updatePageName(t("NAV_ABOUT_US"))}
                          >
                            <ArrowSmallRight />
                            {t("NAV_ABOUT_US")}
                          </NavLink>
                        )}
                        {checkSidebarPermission("faqs") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 text-[#585874] hover:bg-white hover:text-[#8FC150]",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/static/faqs"
                            onClick={() => updatePageName(t("NAV_FAQS"))}
                          >
                            <ArrowSmallRight />
                            {t("NAV_FAQS")}
                          </NavLink>
                        )}
                        {checkSidebarPermission("privacy_policy") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 active:text-LightBlue hover:bg-white hover:text-LightBlue",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/static/privacy-policy"
                            onClick={() =>
                              updatePageName(t("NAV_PRIVACY_POLICY"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_PRIVACY_POLICY")}
                          </NavLink>
                        )}
                        {checkSidebarPermission("terms_and_conditions") && (
                          <NavLink
                            className={({ isActive }) =>
                              classNames(
                                "flex items-center px-6 lg-px-12 py-2 active:text-LightBlue hover:bg-white hover:text-LightBlue",
                                {
                                  active: isActive,
                                },
                              )
                            }
                            to="/static/terms-and-conditions"
                            onClick={() =>
                              updatePageName(t("NAV_TERMS_AND_CONDITIONS"))
                            }
                          >
                            <ArrowSmallRight />
                            {t("NAV_TERMS_AND_CONDITIONS")}
                          </NavLink>
                        )}
                      </Popover.Panel>
                    )}
                  </>
                )}
              </Popover>
            )}

            {checkSidebarPermission("settings") && (
              <NavLink
                to="/settings"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_SETTINGS"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_SETTINGS")}
              </NavLink>
            )}
            {checkSidebarPermission("mortgageSettings") && (
              <NavLink
                to="/mortgageSettings"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("NAV_MORTGAGE_SETTINGS"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("NAV_MORTGAGE_SETTINGS")}
              </NavLink>
            )}
            {checkSidebarPermission("menus_manager") && (
              <NavLink
                to="/top-menus"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("MENU_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("MENU_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("community_manager") && (
              <NavLink
                to="/community"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("COMMUNITY_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("COMMUNITY_MANAGER")}
              </NavLink>
            )}

            {checkSidebarPermission("project_status_manager") && (
              <NavLink
                to="/project-status"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("PROJECT_STATUS_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("PROJECT_STATUS_MANAGER")}
              </NavLink>
            )}
            {checkSidebarPermission("app_home_menu_manager") && (
              <NavLink
                to="/app-home-menu"
                className={({ isActive }) =>
                  classNames(
                    "flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]",
                    {
                      active: isActive,
                    },
                  )
                }
                onClick={() => updatePageName(t("APP_HOME_MENU_MANAGER"))}
              >
                <span className="mr-2">
                  <img src={Setting} className="max-w-[18px]" alt="" />
                </span>
                {t("APP_HOME_MENU_MANAGER")}
              </NavLink>
            )}
            {/* {
              checkSidebarPermission('aml') && (
                <NavLink
                  to='/aml'
                  className={({ isActive }) =>
                    classNames(
                      'flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]',
                      {
                        active: isActive
                      }
                    )
                  }
                  onClick={() => updatePageName(t('NAV_AML'))}
                >
                  <span className='mr-2'>
                    <Documents />
                  </span>
                  {t('NAV_AML')}
                </NavLink>
              )
            } */}

            {/* <Link
              onClick={handleLogout}
              className='flex items-center px-4 lg:px-7 py-4 text-[#585874] hover:text-[#8FC150] text-[14px]'
            >
              <span className='mr-2'>
                <img src={Logout} className='max-w-[18px]' />
              </span>
              {t('NAV_LOGOUT')}
            </Link> */}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
